import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';
import { getProfile, User } from 'lib/personalization/profile';

declare global {
	interface Window {
		scsHeader : {
			positionToolbarFiller() : void;
		}
	}
}


export default class UserBox extends Module {
	private urls : Record<string, string> = {};
	private user : User | undefined;

	public on(callback : Hook) {
		this.urls = this.$ctx.data();
		callback();
	}

	public getLogoutUrl() {
		return this.urls.logoutUrl;
	}

	public getLoginUrl() {
		return this.urls.loginUrl;
	}

	public getResShopUrl() {
		return this.urls.resShopUrl;
	}

	public getSmeShopUrl() {
		return this.urls.logoutUrl;
	}

	public getCbuShopUrl() {
		return this.urls.smeShopUrl;
	}

	public async after() {
		if (this.$ctx.find('#scs-pageheader-userbox-button span.text').length) {
			this.user = (await getProfile()).getUser();
			if (this.user) {
				this.initUserBox();
				this.initUserBoxEvents();
			}
		}
	}

	private initUserBox() {
		const $text = this.$ctx.find('#scs-pageheader-userbox-button span.text');

		$text.addClass('ctHidden');
		$text.text(this.user!.getFullName());
		this.$ctx.show();
		if(window.scsHeader && window.scsHeader.positionToolbarFiller) {
			window.scsHeader.positionToolbarFiller();
		}
	}

	private initUserBoxEvents() {
		// Show/hide menu
		this.$ctx.find('#scs-pageheader-userbox-button').on('click', e => {
			this.$ctx.toggleClass('isActive');
			e.currentTarget.blur();
		});
		// Close menu if something outside the login-box is clicked
		$(document).on('click', () => {
			this.$ctx.removeClass('isActive');
		});
		this.$ctx.on('click', e => {
			e.stopPropagation();
		});
	}
}

let globalUserBox : UserBox | undefined | null;
export function getGlobalUserBox() : UserBox | null {
	if(globalUserBox === undefined) {
		const module = document.getElementById('scs-pageheader-userbox') || document.querySelector('.mod.modUserBox');
		if(!module) {
			globalUserBox = null;
		} else {
			globalUserBox = window.application.sandbox.getModuleInstance(module, 'UserBox') as UserBox;
		}
	}

	return globalUserBox;
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/personalization/Tc.Module.UserBox.ts